exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub-el-icon[data-v-31ea41b3] {\r\n  color: currentColor;\r\n  font-size: 14px !important;\r\n  width: 1em !important;\r\n  height: 1em;\r\n  margin-right: 20px !important;\n}\r\n", ""]);

// exports
